import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskReopened_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import TaskName from 'src/entities/common/TaskName';

interface Fragments {
  activityLog: ActivityLogTaskReopened_ActivityLogFragment;
}

const ActivityLogTaskReopened: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;

  // eslint-disable-next-line no-underscore-dangle
  if (!details || details.__typename !== 'ActivityLogTaskDetails') {
    throw new Error('ActivityLogTaskReopened: details is not ActivityLogTaskDetails');
  }

  const { task } = details;
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.reopenedTaskWithName"
      actionLabelValues={{ taskName: task.name }}
    />
  );
};

ActivityLogTaskReopened.fragments = {
  activityLog: gql`
    ${TaskName.fragments.task}
    ${ActivityLogBase.fragments.activityLog}

    fragment ActivityLogTaskReopened_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogTaskDetails {
          __typename
          taskId
          task {
            id
            ...TaskName_task
          }
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskReopened;
